import { utils } from "../../utils";
const iniUser =
{
    user:
    {
        isAuthenticated: false,
        // googleTokenID: undefined
    },
    loading: false,
    users: []
}

const reducer_user = (state = { ...iniUser }, action) => {


    switch (action.type) {
        case utils.constants.USER_LOGIN_REQUEST: {
            //console.log('--------   action.payload:', action.payload)
            return {
                loading: true,
            }
        }
        case utils.constants.USER_LOGIN_SUCCESS: {
            return {
                ...state,
                loading: false,
                user: {
                    ...action.payload.data,
                    isAuthenticated: action.payload?.data?.name !== undefined
                },
            }
        }
        case utils.constants.USER_LOGOUT_REQUEST: {

            // console.log('\r\n action. LOG OUT:')
            return {
                ...iniUser
            }
        }
        case utils.constants.USER_LOGIN_FAIL: {
            return {
                ...state,
                error: action.payload,
                loading: false
            }
        }
        // case utils.constants.USER_SET_LOGOUT: {
        //     return {
        //         iniUser
        //     }
        // }

        // ADMIN get
        case utils.constants.USER_LIST_REQUEST: {
            return {
                ...state,
                loading: true,
            }
        }
        // ADMIN get
        case utils.constants.USER_LIST_SUCCESS: {

            // console.log('action.payload:', action.payload)
            return {
                ...state,
                loading: false,
                users: action.payload
            }
        }
        // ADMIN get
        case utils.constants.USER_LIST_FAIL: {
            return {
                ...state,
                users_error: action.payload,
                loading: false
            }
        }
        // ADMIN post
        case utils.constants.USER_ADMIN_SAVE_REQUEST: {
            return {
                ...state,
                loading: true,
            }
        }
        // ADMIN post
        case utils.constants.USER_ADMIN_SAVE_SUCCESS: {
            return {
                ...state,
                loading: false,
                users: action.payload
            }
        }
        // ADMIN post
        case utils.constants.USER_ADMIN_SAVE_FAIL: {
            return {
                ...state,
                users_error: action.payload,
                loading: false
            }
        }


        default:
            return { ...state };
    }
}

export default reducer_user